module.exports = __webpack_public_path__ + "static/media/epillax-logo.6aa778f1.png";